export const OFFERING_PERMISSIONS_FIELDS = [
  { field: 'visibleUnauthorized', label: 'Iedereen', defaultValue: false },
  { field: 'visibleSchools', label: 'Scholen', defaultValue: false },
  { field: 'visiblePartners', label: 'Partners', defaultValue: false },
  { field: 'visibleCity', label: 'Stadsmedewerkers', defaultValue: false }
];
